export default () => ({
    sending: false,
    post: {
        attributes: {}
    },

    postView: null,

    posts: null,
    postsConfig: {
        include: '',
        sort: '-id',
        sortDirection: '',
        page: 1,
        filters: '',
        per_page: 15
    },

    unread_messages: null
})
